import * as React from "react";
import Navbar from "./navbar";
import Footer from "./footer";

interface LayoutProps {
  children: React.ReactNode;
  pathname?: string;
}

const Layout: React.FC<LayoutProps> = ({ children, pathname = "/" }) => {
  const footerRef = React.useRef<HTMLElement | null>(null);

  return (
    <div className="min-h-screen overflow-x-hidden">
      <Navbar pathname={pathname} footerRef={footerRef} />
      <main className="pt-18">{children}</main>
      <Footer ref={footerRef} pathname={pathname} />
    </div>
  );
};

export default Layout;
